var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292832 16.2929C-0.0976921 16.6834 -0.0976921 17.3166 0.292832 17.7071C0.683357 18.0976 1.31652 18.0976 1.70705 17.7071L8.99994 10.4142L16.2928 17.7071C16.6834 18.0976 17.3165 18.0976 17.707 17.7071C18.0976 17.3166 18.0976 16.6834 17.707 16.2929L10.4142 9L17.707 1.70711C18.0976 1.31658 18.0976 0.683419 17.707 0.292893C17.3165 -0.097631 16.6834 -0.097631 16.2928 0.292893L8.99994 7.58579L1.70705 0.292894C1.31652 -0.0976299 0.683356 -0.0976299 0.292832 0.292894C-0.0976921 0.683419 -0.0976921 1.31658 0.292832 1.70711L7.58572 9L0.292832 16.2929Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.28d2238f20c442e7678195227fe26cb8.svg";
export { ForwardRef as ReactComponent };